class HelloWorld
  @test: 'test'
console.log('hi')